// A single add-only Data Transfer / Data Erasure completion entry, mapped from the API's camelCase
// row to the PascalCase shape the completion log renders. Mirrors Domain/CommentItem.js.
export default class OpportunitySecurityCompletionItem {
  constructor(item) {
    if (item !== undefined) {
      this.OpportunitySecurityCompletionId = item.opportunitySecurityCompletionId;
      this.CompletionType = item.completionType;
      this.ConfirmedBy = item.confirmedBy;
      this.ConfirmedByName = item.confirmedByName;
      this.ConfirmedOnUtc = item.confirmedOnUtc;
      this.Note = item.note;
    }
  }
}
